import { Box, FormControl, FormLabel, Stack, Text } from '@chakra-ui/react';

import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import {
    descriptionStyling,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';
import { ocUsageTypes } from '../constants';

export default function UsageTypeField({
    darkMode,
    value,
    setFieldValue,
    handleFieldValueChange,
}) {
    const handleChange = (item) => {
        const nextValue = item?.id ?? '';
        setFieldValue('usage', nextValue);
        handleFieldValueChange('usage', nextValue);
    };

    return (
        <FormControl isRequired sx={{ margin: '0 !important' }}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel
                        sx={{
                            ...formLabelStyling(darkMode),
                            paddingTop: '15px',
                        }}>
                        Usage Type
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Please select Usage Type for this order
                    </Text>
                </Box>
                <Box flex="1" minWidth={0}>
                    <DropDown
                        darkMode={darkMode}
                        name="usage"
                        data={ocUsageTypes}
                        shownValue="displayName"
                        currentId={value}
                        handleSelectChange={handleChange}
                        placeholder="Please select Usage Type"
                        width="100%"
                    />
                </Box>
            </Stack>
        </FormControl>
    );
}
